﻿import '../highcharts.js';

window.addEventListener('DOMContentLoaded', () => {
    setStickyNavOffset();
    startWatchResize();
});

/**
 * Gets the height of the title element to use as the offset for the nav element.
 * 
 * TODO: this could be made to be more flexible, like a wrapper sticky-stack that looks for the 
 * child sticky elements and loops through to build the top offset.
 */
function setStickyNavOffset() {
    const comparisonEl = document.querySelector('.upper-panel--sticky-title');
    const destinationEl = document.querySelector('.upper-panel--sticky-nav');

    // Ran into some situations where fractional pixels resulted in a gap between the elements.
    // This reduces the top offset to ensure there is no gap.
    const topOffset = Math.floor(comparisonEl.offsetHeight) - 1;

    if (comparisonEl !== null && destinationEl !== null) {
        destinationEl.style.setProperty('top', `${topOffset}px`);
    }
}

/**
 * Adds an event listener for the resize event, with a debounced function to improve performance.
 */
function startWatchResize() {
    const debouncedNavOffsetFunc = _utils.debounce(setStickyNavOffset, 200);

    window.addEventListener('resize', debouncedNavOffsetFunc);
}

$(window).scroll(function () {
	var allNavItems = document.querySelectorAll('[id*="--nav-item"]');
	var allSections = document.querySelectorAll('section[id]');
	var currentPosition = $(window).scrollTop();

	allSections.forEach(element => {

		var elementTopPosition = $(element).offset().top - 200;
		var elementHeight = $(element).outerHeight();

		if (currentPosition >= elementTopPosition && currentPosition < elementTopPosition + elementHeight) {

			const targetNavItem = document.querySelector(`div[id=${element.id}--nav-item]`);

			if (targetNavItem) {

				allNavItems.forEach(item => _utils.classListRemove(item, 'upper-panel--nav-item__active'));
				_utils.classListAdd(targetNavItem, 'upper-panel--nav-item__active');

			}
		}
	});
})